import { render, staticRenderFns } from "./package-order-list.vue?vue&type=template&id=da5e2eea&scoped=true&"
import script from "./package-order-list.vue?vue&type=script&lang=js&"
export * from "./package-order-list.vue?vue&type=script&lang=js&"
import style0 from "./package-order-list.vue?vue&type=style&index=0&id=da5e2eea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5e2eea",
  null
  
)

export default component.exports